import {Component} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {MailTemplateService} from './mailTemplate.service';

@Component({
  selector: 'mailTemplate-grid',
  templateUrl: './mailTemplate.component.html',
  styleUrls: ['./mailTemplate.component.css'],
  providers: [MailTemplateService],
})
export class MailTemplateComponent extends BaseGridNoCookieComponent<MailTemplateService> {
  debtorId: any = null;
  template: any;
  error: any;
  public emailForm: UntypedFormGroup;
  debtorForm: UntypedFormGroup;
  loading = false;
  loadingDone = false;
  isEditing: boolean = false;
  enableBuyerImgFeature: boolean = false;
  imageSrc: any = null;
  viewRole: any;
  imageBuyer: any;
  buyerCmpNm: string = 'buyerCmpNm';
  constructor(
    public gridService: MailTemplateService,
    public fb: UntypedFormBuilder,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    visualsService: VisualsService,
    public route: ActivatedRoute,
  ) {
    super(securityService, logger, visualsService, gridService, 'mailTemplate');
    this.loadVisuals();
    this.viewRole = this.securityService.isOtherStaff();
    this.buildDebtorForm();

    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
      },
    });
    this.emailForm = this.fb.group({
      invLogo: [''],
      invHeader: [''],
      invFooter: [''],
      dbtrId: [''],
      invLogoName: [''],
      invLogoExt: [''],
    });
  }

  buildDebtorForm() {
    this.debtorForm = this.fb.group({
      debtorId: ['', [Validators.required, Validators.maxLength(10)]],
    });
  }

  clearImage() {
    this.emailForm.controls['invLogo'].setValue('');
    this.emailForm.controls['invLogoExt'].setValue('');
    this.emailForm.controls['invLogoName'].setValue('');
  }

  handleInputChange(e) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    let size = e.target.files[0].size;
    if (size >= 5242880) {
      this.error = 'Maximum upload size exceeded. Allowed up to 5 MB';
      return;
    } else {
      this.error = '';
    }
    var reader = new FileReader();
    const name = e.target.files[0].name;
    const lastDot = name.lastIndexOf('.');
    const fileName = name.substring(0, lastDot);
    const ext = '.' + name.substring(lastDot + 1);
    this.emailForm.patchValue({invLogoName: fileName});
    this.emailForm.patchValue({invLogoExt: ext});
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    var reader = e.target;
    this.imageSrc = reader.result;
    let base64result = reader.result.split(',')[1];
    this.emailForm.patchValue({invLogo: base64result});
  }

  public valueChanged(modalname: string, value: any) {
    this.debtorId = value.dbtrId;
    this.debtorForm.controls['debtorId'].setValue(this.debtorId);
  }

  checkDebtorId(functionality) {
    this.debtorId = this.debtorForm.controls.debtorId.value;

    if (this.debtorId == '' || this.debtorId == null) {
      LogService.emitAlert({
        type: 'info',
        body: 'You need to choose Buyer first',
      });
    } else {
      this.loading = true;
    }
  }

  public search() {
    this.debtorId = this.debtorForm.controls.debtorId.value;
    if (this.debtorId == '' || this.debtorId == null) {
      LogService.emitAlert({
        type: 'info',
        body: 'You need to choose Buyer first',
      });
    } else {
      this.loading = true;
      this.loadingDone = false;
      this.gridService.checkDebtorId(this.debtorId).subscribe({
        next: (data) => {
          this.isEditing = true;
          this.gridService.getTemplate(this.debtorId).subscribe({
            next: (data) => {
              this.template = data.data;
              this.imageSrc = 'data:image/jpeg;base64,' + this.template.invLogo;
              this.imageBuyer = 'data:image/jpeg;base64,' + this.template.invLogo;
              this.emailForm = this.fb.group({
                invLogo: this.template.invLogo,
                invHeader: this.template.invHeader,
                invFooter: this.template.invFooter,
                dbtrId: this.debtorId,
                invLogoName: this.template.invLogoName,
                invLogoExt: this.template.invLogoExt,
              });
              this.loading = false;
              this.loadingDone = true;
              this.isEditing = false;
              this.getNotification();
            },
            error: (error) => {
              this.logger.error(error);
              this.loading = false;
              this.loadingDone = true;
              this.isEditing = false;
            },
          });
        },
        error: (error) => {
          this.logger.error(error);
          this.loading = false;
          this.isEditing = false;
        },
      });
    }
  }
  content;
  getNotification() {
    this.loadingDone = false;
    this.loading = true;
    this.gridService.getNotification(this.debtorId, 'B_INVITATION_HTML').subscribe({
      next: (response) => {
        if (!response.success) throw new Error(response.message);
        this.content = response.data.replace(/{{([^}}]+)?}}/g, ($1, $2) =>
          $2.split('.').reduce((p, c) => (p ? p[c] : ''), this),
        );
        this.loadingDone = true;
      },
      error: () => {},
      complete: () => {
        this.loading = false;
      },
    });
  }

  save(form) {
    this.gridService.saveTemplate(this.emailForm.value).subscribe({
      next: (data) => {
        LogService.emitAlert({
          type: 'success',
          body: data.message,
        });
        this.search();
      },
      error: (error) => {
        this.logger.info(error);
      },
    });
  }
}
